import { Button } from "primereact/button";

export function EventHeaderActions(props: {
  title: string;
  isPublished: boolean;
  isCancelled: boolean;
  isBookable?: boolean;
  onBack: () => void;
  onPublish: () => void;
  onUnpublish: () => void;
  onCancel: () => void;
  onUncancel: () => void;
  onEditDetails: () => void;
  onClone: () => void;
  onViewParticipants: () => void;
}) {
  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2">
        <div className="flex align-items-center gap-3">
          <Button
            icon="pi pi-arrow-left"
            label="Back"
            className="p-button-text"
            onClick={props.onBack}
          />
          <h1 className="text-2xl font-bold m-0">{props.title}</h1>
        </div>
        <div className="flex gap-2 flex-wrap align-items-center">
          {props.isPublished ? (
            <>
              <Button
                label="Unpublish"
                icon="pi pi-eye-slash"
                severity="warning"
                onClick={props.onUnpublish}
                className="w-full md:w-auto"
              />
              {props.isCancelled ? (
                <Button
                  label="Uncancel"
                  icon="pi pi-check"
                  severity="success"
                  onClick={props.onUncancel}
                  className="w-full md:w-auto"
                />
              ) : (
                <Button
                  label="Cancel Event"
                  icon="pi pi-times"
                  severity="danger"
                  onClick={props.onCancel}
                  className="w-full md:w-auto"
                />
              )}
            </>
          ) : (
            <Button
              label="Publish"
              icon="pi pi-eye"
              severity="success"
              onClick={props.onPublish}
              className="w-full md:w-auto"
            />
          )}
          <Button
            label="Edit Details"
            icon="pi pi-pencil"
            onClick={props.onEditDetails}
            className="w-full md:w-auto"
          />
          <Button
            label="Clone"
            icon="pi pi-copy"
            onClick={props.onClone}
            className="w-full md:w-auto"
            outlined
          />
          {props.isBookable !== false && (
            <Button
              label="View Participants"
              icon="pi pi-users"
              onClick={props.onViewParticipants}
              className="w-full md:w-auto"
            />
          )}
        </div>
      </div>
    </div>
  );
}







